import React from "react";

function Header() {
  return (
    <header>
      <div>
        <img
          className="headerImg"
          src="https://www.phbs.pku.edu.cn/dfiles/26057/uploadfile/2022/0110/20220110050242746.jpg"
          alt="headerImg"
        />
      </div>
      <h1>
        北大汇丰智库 · 萨金特数量经济与金融研究所 · 宏观经济实时预测
        <br />
        <small>PHBS Think Tank· SIQFE · Macroeconomic Nowcasting</small>
      </h1>
    </header>
  );
}

export default Header;
